import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { CustomerOrderBillingPlanLinesToApproveDataGrid } from "src/components/views/erp/sales/billingPlan/customerOrder/CustomerOrderBillingPlanLinesToApproveDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/sales/billingPlanLinesToApprove")({
	staticData: { title: i18n.t("unapproved_billing_plan_lines"), legacyViewKey: "billingPlanLinesToApproveView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <CustomerOrderBillingPlanLinesToApproveDataGrid />;
}
